import React, { useState } from "react";
import type { CsrAssistEnquiry } from "./csrAssistApi";

interface CsrAssistEnquiresPanelProps {
  enquiries: CsrAssistEnquiry[];
  loading: boolean;
  error: string | null;
  hasConversation: boolean;
}

export default function CsrAssistEnquiresPanel({
  enquiries,
  loading,
  error,
  hasConversation,
}: CsrAssistEnquiresPanelProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  if (!hasConversation) {
    return (
      <section className="csr-assist-empty">
        <p>
          Questions the customer asks during the call will appear here with
          prefetched CSR answers.
        </p>
      </section>
    );
  }

  return (
    <section className="csr-assist-panel" aria-label="CSR assist enquires">
      {error && enquiries.length ? (
        <p className="csr-assist-error csr-assist-error--soft">
          Some answers could not be loaded. Customer questions are still listed
          below.
        </p>
      ) : null}

      {error && !enquiries.length ? (
        <p className="csr-assist-error">{error}</p>
      ) : null}

      {!enquiries.length ? (
        <p className="csr-assist-empty-inline">
          No customer questions yet. When the caller asks about coverage,
          documents, or next steps, they will show up here.
        </p>
      ) : null}

      <div className="csr-assist-list">
        {enquiries.map((enquiry) => {
          const isOpen = expandedId === enquiry.id;
          const answerReady = Boolean(enquiry.answer?.trim());

          return (
            <article key={enquiry.id} className="csr-assist-item">
              <button
                type="button"
                className={`csr-assist-question${isOpen ? " open" : ""}`}
                aria-expanded={isOpen}
                onClick={() =>
                  setExpandedId(isOpen ? null : enquiry.id)
                }
              >
                <span className="csr-assist-question__text">
                  {enquiry.question}
                </span>
                <span className="csr-assist-question__chevron" aria-hidden="true">
                  {isOpen ? "▾" : "▸"}
                </span>
              </button>

              {isOpen ? (
                <div className="csr-assist-answer">
                  {answerReady ? (
                    <p>{enquiry.answer}</p>
                  ) : (
                    <p className="csr-assist-answer--pending">
                      Preparing CSR answer…
                    </p>
                  )}
                </div>
              ) : null}
            </article>
          );
        })}
      </div>
    </section>
  );
}
